'use client';

import { ReactNode } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { emitHomeReset } from '@/features/listings/components/HomeSearchMode';

type Props = {
    className?: string;
    children: ReactNode;
};

/**
 * Logo v hlavicke. Na homepage klik nerobi navigaciu (uz sme na "/"),
 * ale resetne search mode - vrati klasicku homepage (TOP ponuky, RealicoX
 * banner...) a vycisti smart input. Inde je to obycajny Link na "/".
 */
export function LogoLink(props: Props) {
    const pathname = usePathname();

    return (
        <Link
            href="/"
            className={props.className}
            onClick={(e) => {
                if (pathname !== '/') return;
                e.preventDefault();
                emitHomeReset();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
        >
            {props.children}
        </Link>
    );
}
